module.exports = __webpack_public_path__ + "img/pass_right.a7672c4d.jpg";